export const langStub = [{
  'option': 'EN',
  'title': 'English'
},
{
  'option': 'ES',
  'title': 'Spanish'
},
{
  'option': 'FR',
  'title': 'French'
}];
